import { AlertTriangle } from 'lucide-react';
import { useLicense } from './useLicense';
import styles from '../auth/PasswordExpiringBanner.module.css';

/** Faixa da clinica em so leitura (licenca `aplicar` com status != ativa). */
export function LicenseReadOnlyBanner() {
  const { clinicReadOnly } = useLicense();
  if (!clinicReadOnly) return null;
  return (
    <div className={styles.banner} role="status">
      <span className={styles.icon}><AlertTriangle size={18} aria-hidden="true" /></span>
      <p className={styles.text}>A clínica está em modo só leitura: dá para consultar, imprimir e baixar, mas não alterar.</p>
    </div>
  );
}
